// Use esse hook se precisar fazer check de itens com alguma tabela que possua paginação pelo BackEnd.
import { useState, useCallback, useEffect } from 'react'

interface IUseCheckListProps<T> {
  keyName: keyof T
  onSelectItem?: (_items: T[]) => void
}

interface IUseCheckListReturn<T> {
  data: T[]
  selectedItems: T[]
  handleSelectItem: (_row: T) => void
  handleToWaive: (_row: T) => void
  setData: React.Dispatch<React.SetStateAction<T[]>>
  handleClearSelectedItems: () => void
  isAllChecked: boolean
  handleCheckAll: () => void
}

const useCheckListWithPagination = <T>(
  props: IUseCheckListProps<T>
): IUseCheckListReturn<T> => {
  const [data, setData] = useState<T[]>([])
  const [selectedItems, setSelectedItems] = useState<T[]>([])
  const [selectedItemsDataEvent, setSelectedItemsDataEvent] = useState<T[]>([])

  const getSelectedItemsReference = useCallback((): any[] => {
    return selectedItems.map((item) => item[props.keyName])
  }, [selectedItems])

  const getCurrentPageItemsReference = useCallback((): any[] => {
    return data.map((item) => item[props.keyName])
  }, [data])

  const getData = (): T[] => {
    return data?.map((item) => ({
      ...item,
      checked: getSelectedItemsReference().includes(item[props.keyName])
    }))
  }

  const isAllChecked = (): boolean => {
    const allItemsOfPageCheckedStatus = !getData()
      ?.map((item) => item['checked'])
      .includes(false)

    return allItemsOfPageCheckedStatus
  }

  const handleDischeckAll = () => {
    setSelectedItems((prevState) =>
      prevState.filter(
        (item) => !getCurrentPageItemsReference().includes(item[props.keyName])
      )
    )
    setSelectedItemsDataEvent((prevState) =>
      prevState.filter(
        (item) => !getCurrentPageItemsReference().includes(item[props.keyName])
      )
    )
  }

  const handleCheckAll = () => {
    if (isAllChecked()) {
      handleDischeckAll()
      return
    }

    setSelectedItems((prevState) => [...prevState, ...data])
    setSelectedItemsDataEvent((prevState) => [...prevState, ...data])
  }

  const handleSelectItem = (row: T) => {
    const selectedItem = data.find(
      (item) => item[props.keyName] === row[props.keyName]
    )

    setSelectedItems((prevState) => [...prevState, selectedItem])
    setSelectedItemsDataEvent((prevState) => [...prevState, selectedItem])
  }

  const handleToWaive = (row: T) => {
    setSelectedItems((prevState) =>
      prevState.filter((item) => item[props.keyName] !== row[props.keyName])
    )
    setSelectedItemsDataEvent((prevState) =>
      prevState.filter((item) => item[props.keyName] !== row[props.keyName])
    )
  }

  const handleClearSelectedItems = () => {
    setSelectedItems([])
  }

  useEffect(() => {
    props.onSelectItem(selectedItemsDataEvent)
  }, [selectedItemsDataEvent])

  return {
    data: getData(),
    handleCheckAll,
    handleClearSelectedItems,
    handleSelectItem,
    handleToWaive,
    isAllChecked: isAllChecked(),
    selectedItems,
    setData
  }
}

export default useCheckListWithPagination
